import React, { useState, useContext, useEffect } from "react"; // Добавляем useEffect
import { UserContext } from "../../contexts/CurrentUserContext";
import "./EmployeeCard.css";
import EmployeePhoto from "../../images/cat-photo.png";
import Preloader from "../Preloader/Preloader"; // Импортируем Preloader

function EmployeeCard() {
  const { userData } = useContext(UserContext);
  const [isBlurred, setIsBlurred] = useState(true);
  const [loading, setLoading] = useState(true); // Добавляем состояние загрузки
  const [showPhotoPopup, setShowPhotoPopup] = useState(false); // Добавляем состояние для попапа

  useEffect(() => {
    if (userData) {
      setLoading(false); // Устанавливаем загрузку в false, когда userData загружены
    }
  }, [userData]);

  const toggleBlur = () => {
    setIsBlurred(!isBlurred);
  };

  const openPhotoPopup = () => {
    setShowPhotoPopup(true);
  };

  const closePhotoPopup = () => {
    setShowPhotoPopup(false);
  };

  const formatSalary = (salary) => {
    if (!salary) return "Не указано";
    return salary.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return "Не указано";
    return phoneNumber.replace(
      /(\+\d)(\d{3})(\d{3})(\d{2})(\d{2})/,
      "$1 ($2) $3-$4-$5"
    );
  };

  if (loading) {
    return <Preloader />; // Показываем Preloader во время загрузки
  }

  if (!userData) {
    return <Preloader />;
  }

  return (
    <div className="employee-card">
      <div className="employee-info">
        <h2 className="employee-name">
          {userData.surname} {userData.name} {userData.patronymic}
        </h2>

        {userData.departments && userData.departments.length > 0 && (
          <div className="employee-structure">
            {userData.departments.map((department, deptIndex) => (
              <div key={deptIndex} className="employee-department-container">
                <p className="employee-department-name">{department.name}</p>
                {department.groups && department.groups.length > 0 && (
                  <div className="employee-groups">
                    {department.groups.map((group, groupIndex) => (
                      <div key={groupIndex} className="employee-group">
                        <p className="employee-group-name">{group.name}</p>
                        {group.roles && group.roles.length > 0 && (
                          <p className="employee-role">
                            Должность: {group.roles[0].name}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="employee-photo">
        <img
          src={userData.image || EmployeePhoto}
          alt="Фото сотрудника"
          onClick={openPhotoPopup}
          className="employee-photo-clickable"
        />
      </div>

      <div className="employee-bottom-info">
        {userData.salary && (
          <p className="employee-salary">
            Оклад:{" "}
            <span className={isBlurred ? "blurred" : ""} onClick={toggleBlur}>
              {formatSalary(userData.salary)}
            </span>{" "}
            тг
          </p>
        )}

        {userData.hire_date && (
          <p className="employee-hiring-date">
            Принят на работу {userData.hire_date}
          </p>
        )}
      </div>

      <div className="employee-details">
        <p className="employee-detail">Логин: {userData.username}</p>
        <p className="employee-detail">
          {formatPhoneNumber(userData.phone_number)}
        </p>
        <p className="employee-detail">Email: {userData.email}</p>
      </div>

      {/* Попап для просмотра фотографии */}
      {showPhotoPopup && (
        <div className="photo-popup-overlay" onClick={closePhotoPopup}>
          <div
            className="photo-popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="photo-popup-close" onClick={closePhotoPopup}>
              ×
            </button>
            <img
              src={userData.image || EmployeePhoto}
              alt="Фото сотрудника"
              className="photo-popup-image"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default EmployeeCard;
